export const content = {
  THEMA_TOOLTIP: 'Nach Themen suchen in den Feldern "Titel", "AKA-Produkt-ID", "BNR" oder "V-Nummer"',
  VERANSTALTUNG_TOOLTIP:
    'Nach Veranstaltungen suchen in den Feldern "Titel", "AKA-Veranstaltung-ID", "SAP-E-ID", "BNR" oder "V-Nummer"',
} as const;
